
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class PaginationControl extends Vue {
  @Prop({ required: true }) public label!: string;
  @Prop({ required: true }) public currentPage!: number;
  @Prop({ required: true }) public totalItems!: number;
  @Prop({ required: true }) public itemsPerPage!: number;

  public localPage: number = this.currentPage;

  public get maxPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }

  public get isInvalidPage(): boolean {
    return this.localPage < 1 || this.localPage > this.maxPages;
  }

  @Emit("page-change")
  public goToPage(): number | null {
    if (!this.isInvalidPage) {
      return this.localPage;
    }
    return null;
  }

  @Watch("currentPage")
  public onCurrentPageChanged(newPage: number): void {
    this.localPage = newPage;
  }
}
